import { BusStopHeader } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopHeader";
import {
  BusStopGrid,
  BusStopGridBody,
} from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopGrid";
import { BusStopTableBody } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/BusStopTableBody";
import { useTranslation } from "react-i18next";
import {
  AlternativeTransportVehicle,
  StopReference,
} from "shared/types/alternativeTransport";

interface IncidentsAndStopsPanelsProps {
  vehicle: AlternativeTransportVehicle;
  distributionStopReferences: Array<StopReference>;
}

export const IncidentsAndStopsPanels = ({
  vehicle,
  distributionStopReferences,
}: IncidentsAndStopsPanelsProps) => {
  const { t } = useTranslation();

  return (
    <BusStopGrid aria-label={t("Holdeplass")} role="table">
      <div role="rowgroup">
        <BusStopHeader />
      </div>
      <BusStopGridBody role="rowgroup">
        <BusStopTableBody
          id={vehicle.id}
          itinerary={vehicle.itinerary}
          travelDate={vehicle.scheduledDepartureTimeOrigin}
          vehicleStatus={vehicle.vehicleStatus}
          distributionStopReferences={distributionStopReferences}
        />
      </BusStopGridBody>
    </BusStopGrid>
  );
};
